import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage } from 'react-intl';

type ThemeOptionsArrayValue = {
    name: string;
    id: string;
};

type DropdownSelectFormProps = {
    onChange?: (value: string) => void;
    value?: string;
    classNames: {
        itemTextClassName?: string;
        textField?: string;
        cssSelectRoot?: string;
        cssUnderline?: string;
        menu?: string;
        formInput?: string;
        wrapper?: string;
    };
    formattedMessage: {
        id: string;
        defaultMessage: string;
    };
    menuItems: {
        options: ThemeOptionsArrayValue[];
    };
};

const DropdownSelectForm = ({
    onChange,
    value,
    classNames = {},
    formattedMessage,
    menuItems,
}: DropdownSelectFormProps): React.ReactElement => (
    <Grid id="yeself-settings-ch-position" container className={classNames.wrapper}>
        <Typography variant="body1" className={classNames.itemTextClassName}>
            <FormattedMessage
                id={formattedMessage.id}
                defaultMessage={formattedMessage.defaultMessage}
            />
        </Typography>
        <Grid id="yeself-dropdown-select-form" item className={classNames.formInput}>
            <TextField
                value={value}
                onChange={(event) => onChange && onChange(event.target.value)}
                select
                fullWidth
                className={classNames.textField}
                margin="normal"
                variant="filled"
                InputProps={{
                    classes: {
                        root: classNames.cssSelectRoot,
                        underline: classNames.cssUnderline,
                    },
                }}
                SelectProps={{
                    MenuProps: {
                        className: classNames.menu,
                    },
                }}
            >
                {menuItems.options.map((option) => (
                    <MenuItem id="yeself-menu-item" value={option.id} key={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    </Grid>
);

export default DropdownSelectForm;
